import { render, staticRenderFns } from "./srPartnerFooter.vue?vue&type=template&id=583c0856&scoped=true"
import script from "./srPartnerFooter.vue?vue&type=script&lang=js"
export * from "./srPartnerFooter.vue?vue&type=script&lang=js"
import style0 from "./srPartnerFooter.vue?vue&type=style&index=0&id=583c0856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c0856",
  null
  
)

export default component.exports